import { createSvgIcon } from "@mui/material";

const RerunIcon = createSvgIcon(
  <svg viewBox="0 0 18 18" fill="none">
    <path
      d="M9.9449 1.87506C6.1274 1.77006 2.9999 4.83756 2.9999 8.62506H1.6574C1.3199 8.62506 1.1549 9.03006 1.3949 9.26256L3.4874 11.3626C3.6374 11.5126 3.8699 11.5126 4.0199 11.3626L6.1124 9.26256C6.3449 9.03006 6.1799 8.62506 5.8424 8.62506H4.4999C4.4999 5.70006 6.8849 3.33756 9.8249 3.37506C12.6149 3.41256 14.9624 5.76006 14.9999 8.55006C15.0374 11.4826 12.6749 13.8751 9.7499 13.8751C8.5424 13.8751 7.4249 13.4626 6.5399 12.7651C6.2399 12.5326 5.8199 12.5551 5.5499 12.8251C5.2349 13.1401 5.2574 13.6726 5.6099 13.9426C6.7499 14.8426 8.1824 15.3751 9.7499 15.3751C13.5374 15.3751 16.6049 12.2476 16.4999 8.43006C16.4024 4.91256 13.4624 1.97256 9.9449 1.87506Z"
      fill="currentColor"
    />
    <path
      d="M12.4227 8.92033L9.158 11.0317C8.95211 11.1444 8.7428 11.1528 8.53006 11.0571C8.31731 10.9614 8.21094 10.8122 8.21094 10.6095V6.38663C8.21094 6.18394 8.31731 6.03473 8.53006 5.93901C8.7428 5.8433 8.95211 5.85174 9.158 5.96435L12.4227 8.07576C12.6149 8.17711 12.7109 8.31787 12.7109 8.49805C12.7109 8.67822 12.6149 8.81898 12.4227 8.92033Z"
      fill="currentColor"
    />
  </svg>,
  "RerunIcon"
);

export default RerunIcon;
